import {
  Component,
  OnInit,
  OnDestroy,
  ViewEncapsulation,
  HostListener,
  ChangeDetectorRef,
  AfterViewChecked,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { DomSanitizer, SafeUrl, Title } from "@angular/platform-browser";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";

import moment from "moment";
import { cloneDeep } from "lodash";

import { Color } from "@angular-material-components/color-picker";
import { MatSelectionListChange } from "@angular/material/list";
import { MatDialog } from "@angular/material/dialog";

import { BehaviorSubject, EMPTY, Observable, of, Subject, Subscription, zip } from "rxjs";
import { catchError, filter, finalize, map, shareReplay, skip, switchMap, take, takeUntil, tap } from "rxjs/operators";
import { select, Store } from "@ngrx/store";
import {
  createProduct,
  getBarcodeTypes,
  getCategoriesByUsage,
  getFamilyProductsList,
  getGroupProductsList,
  getProduct,
  getProductTypesList,
  getPropertiesByUsage,
  getUnitProductsList,
  resetProduct,
  updateProduct,
} from "src/app/store/actions/products/product.actions";
import { getProductGroupList } from "src/app/store/actions/productGroups/productGroup.actions";
// import { getProductFamiliesList } from "src/app/store/actions/productFamilies/productFamilies.actions";
import {
  AppState,
  createdProductState,
  getTimezone,
  loadedBarcodeTypesListState,
  // loadedFamilyListState,
  loadedProductGroupsListState,
  loadedProductIsLoadingState,
  loadedProductsCategoriesState,
  loadedProductsPropertiesState,
  loadedProductState,
  loadedProductTypesListState,
  loadedProductUnitListState,
  loadedTenantState,
  loginStateLocaleList,
  messagesStateGetMessage,
} from "src/app/store/reducers";
import { setSnackbar } from "src/app/store/actions/messages/message.actions";
import { getSitesList } from "src/app/store/actions/sites/sites.actions";

import { TranslateService } from "@ngx-translate/core";
import { SnackbarService } from "src/app/shared/services/snackbar/snackbar.service";
import { TaxesService } from "src/app/shared/services/taxes/taxes.service";

import { AppMessage } from "src/app/models/common/appMessage";
import { FormUtils } from "src/app/shared/utils/formUtils";
import { SnackbarType } from "src/app/models/snackbar/snackbar.model";
import {
  BarcodeTypeDTO,
  PackDTO,
  PackExtendedDTO,
  ProductDTO,
  ProductFamilyDTO,
  ProductGroupDTO,
  ProductTypeDTO,
  ProductUnitDTO,
} from "src/app/models/Products/productDTO";
import { TopCard } from "src/app/models/top-card/top-card.model";
import { CategoryDTO } from "src/app/models/Categories/categoryDTO";
import { PropertyDTO } from "src/app/models/Properties/propertyDTO";
import { CategoriesAndPropsUtils } from "src/app/shared/utils/categoriesAndPropsUtils";
import { CanComponentDeactivate } from "src/app/shared";
import {
  Dialog,
  GuardConfirmationDialogData,
} from "src/app/models/dialog/dialog.model";
import { AutocompleteSelectItem } from "src/app/models/selection-list/autocomplete-select-item.model";
import { TaxDTO, TaxExtendedDTO, TaxViewDTO } from "src/app/models/taxes/tax.model";
import { isAuthenticated } from "src/app/shared/utils/authenticationUtils";
import { getColorByBgColor } from "src/app/shared/utils/colorUtils";
import { SnackBarUtils } from "src/app/shared/utils/snackbarUtils";

import { ConfirmationDialogComponent } from "src/app/shared/modules/dialogs/confirmation-dialog/confirmation-dialog.component";
import { ProductFamilyService } from "src/app/shared/services/products/productFamily/productFamily.service";
import { ManageFilesDialogComponent } from "src/app/shared/modules/dialogs/manage-files-dialog/manage-files-dialog.component";
import { ManageFileService } from "src/app/shared/services/manage-files/manage-files.service";
import { RolePermissionsService } from "src/app/shared/services/role-permissions/role-permissions.service";
import { DescriptionLocaleFormDialogComponent } from "src/app/shared/modules/dialogs/description-locale-form-dialog/description-locale-form-dialog.component";
import { buildDetailedDescription, populateDetailedDescription, setDetailedDescription, setFormAfterDialogClosed } from "src/app/shared/utils/localeDescriptionUtils";
import { UserLocaleDTO } from "src/app/models/UserDetails/userLocaleDTO";
import { SitesService } from "src/app/shared/services/sites/sites.service";
import { SiteDTO } from "src/app/models/Sites/siteDTO";
import { RegionDTO } from '../../../models/Sites/siteCustomDTO';

const USAGE_CODE = "PRODUCT";

export const FORM_PARAMS = {
  enabled: "enabled",
  isFuel: "isFuel",
  // promptQuantity: "promptQuantity",
  // promptPrice: "promptPrice",
  // priceByWeight: "priceByWeight",
  // fiscalInfoRequired: "fiscalInfoRequired",
  refundable: "refundable",
  // canSellBelowBuyPrice: "canSellBelowBuyPrice",
  code: "code",
  description: "description",
  detailedDescription: "detailedDescription",
  productUnitCode: "productUnitCode",
  productTypeCode: "productTypeCode",
  productFamily: "productFamily",
  productGroup: "productGroup",
  tax: "tax",
  unitPriceNet: "unitPriceNet",
  unitPriceGross: "unitPriceGross",
  defaultQuantity: "defaultQuantity",
  refundMaxPeriod: "refundMaxPeriod",
  productColor: "productColor",
  imageUrl: "imageUrl",
  shortDescription: "shortDescription",
  detailedShortDescription: "detailedShortDescription",
  lastSaleDate: "lastSaleDate",
  lastBuyDate: "lastBuyDate",
  lastSalePrice: "lastSalePrice",
  lastBuyPrice: "lastBuyPrice",
  maxSellDiscount: "maxSellDiscount",
  categories: "categories",
  properties: "properties",
  barcodes: "barcodes",
  composite: "composite",
  productComposite: "productComposite",
  profitMargin: "profitMargin"
};

@Component({
  selector: "app-product-detail",
  templateUrl: "./product-detail.component.html",
  styleUrls: ["./product-detail.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ProductDetailComponent
  implements OnInit, OnDestroy, AfterViewChecked, CanComponentDeactivate
{
  productInfoTabs = [
    {
      description: "Tabs.BasicData",
      icon: "description",
      selected: true,
    },
    {
      description: "Products.barcodes",
      icon: "qr_code",
      selected: false,
    },
    {
      description: "Products.packs",
      icon: "layers",
      selected: false,
    },
    {
      description: "Tabs.Suppliers",
      icon: "local_shipping",
      selected: false,
    },
    {
      description: "Tabs.Sites",
      icon: "add_location_alt",
      selected: false,
    },
  ];

  //Product
  isLoading$: Observable<boolean>;
  loadedProduct$: Observable<ProductDTO>;
  created$: Observable<boolean>;

  //top-card configuration
  card: TopCard;
  icon: any = "add";

  // Permissions
  public canWrite$: Observable<boolean>;
  canWrite: boolean = false;

  canReadProductFamilies$: Observable<boolean>;
  canReadProductGroups$: Observable<boolean>;
  canReadTaxes$: Observable<boolean>;

  //ProductFamily
  isLoadingProductFamily$ = new BehaviorSubject<boolean>(false);
  productFamiliesList$: Observable<ProductFamilyDTO[]>;
  productFamiliesList: AutocompleteSelectItem[] = [];
  productFamiliesSub: Subscription;

  //ProductGroup
  isLoadingProductGroup$: Observable<boolean>;
  productGroupsList$: Observable<ProductGroupDTO[]>;
  productGroupsList: AutocompleteSelectItem[] = [];
  productGroupsSub: Subscription;

  //Tax
  isLoadingTax$ = new BehaviorSubject<boolean>(false);
  taxesList$: Observable<TaxDTO[]>;
  taxesList: AutocompleteSelectItem[] = [];
  taxesSub: Subscription;
  taxSub: Subscription;
  currentTax: TaxExtendedDTO;

  searchTimer: number;

  //ProductUnit
  productUnits$: Observable<ProductUnitDTO[]>;
  productUnits: ProductUnitDTO[];

  //ProductTypes
  productTypes$: Observable<ProductTypeDTO[]>;
  productTypes: ProductTypeDTO[];

  //Category List
  categoryList$: Observable<CategoryDTO[]>;
  categoryList: CategoryDTO[];

  //Property List
  propertyList$: Observable<PropertyDTO[]>;
  propertyList: PropertyDTO[];

  //Barcode Types
  barcodeTypes$: Observable<BarcodeTypeDTO[]>;

  //Subscriptions
  loadedProductSubs: Subscription;
  createdSub: Subscription;
  multiSubs: Subscription;
  volumeSub: BehaviorSubject<string>;
  protected destroy$ = new Subject<void>();

  //Tenant Data
  tenantDataSub: Subscription;
  tenantData$: Observable<any>;
  priceDecimalPlaces: number;
  forecourtUnitPriceDecimalPlaces: number;
  unitPriceDecimalPlaces: number;
  dateTimeFormat: string;
  coinSymbol: string;
  relevantUomDecimalPlaces: number;
  uomDecimalPlaces: number;
  forecourtUomDecimalPlaces: number;

  //Messages
  message$: Observable<AppMessage>;
  messageSubs: Subscription;

  //Navigation
  currCode: string;

  currentProduct: ProductDTO;
  current: any;

  //Actions
  creation: boolean = false;
  duplication: boolean = false;

  //Form
  productDataForm: FormGroup;

  //Region LedSite
  regionMatchedLedSite?: RegionDTO;

  //Files
  selectedFiles: string[];
  public selectedFilesChip: { name: string; id: string }[] = [];

  //Thumbnail
  public thumbnail$ = new BehaviorSubject<SafeUrl | null>(null);
  private thumbnailCache: Record<string, SafeUrl> = {};
  private fileThumbnails: Record<string, Observable<SafeUrl>> = {};

  //Language
  langSubscription: Subscription;

  timezone: string;
  timezone$: Observable<string>;
  timezoneSubscription: Subscription;

  // loaded locale
  public locale: string = localStorage.getItem("locale");
  localeDesc: string;

  //Locales
  localesList$: Observable<UserLocaleDTO[]>;
  localesListSub: Subscription;

  //Navigate
  productCode: string;

  constructor(
    private translate: TranslateService,
    private fb: FormBuilder,
    private titleService: Title,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private store: Store<AppState>,
    private snackbarService: SnackbarService,
    private taxesService: TaxesService,
    private productFamilyService: ProductFamilyService,
    private manageFileService: ManageFileService,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
    public rolePermissionsService: RolePermissionsService,
    private taxService: TaxesService,
    private sitesService: SitesService
  ) {
    this.titleService.setTitle(this.translate.instant("Products.Details"));
    this.isLoading$ = this.store.pipe(select(loadedProductIsLoadingState));
    this.tenantData$ = this.store.pipe(select(loadedTenantState));
    this.timezone$ = this.store.pipe(select(getTimezone));
    this.localesList$ = this.store.pipe(select(loginStateLocaleList));
    this.message$ = this.store.pipe(select(messagesStateGetMessage));
    this.loadedProduct$ = this.store.pipe(select(loadedProductState));
    this.created$ = this.store.pipe(select(createdProductState));
    this.productGroupsList$ = this.store.pipe(
      select(loadedProductGroupsListState)
    );
    this.productUnits$ = this.store.pipe(select(loadedProductUnitListState));
    this.productTypes$ = this.store.pipe(select(loadedProductTypesListState));
    this.barcodeTypes$ = this.store.pipe(select(loadedBarcodeTypesListState));
    this.categoryList$ = this.store.pipe(select(loadedProductsCategoriesState));
    this.propertyList$ = this.store.pipe(select(loadedProductsPropertiesState));

    this.card = {
      avatarUrl: "",
      content: "",
      imageUrl: "",
      current: "",
      title: "Products.newProduct",
      subtitle: this.duplication ? "Products.duplication" : "Products.creation",
    };
  }

  confirmDialog(dialog: any, refresh = false): Observable<boolean> {
    const dialogData: Dialog = GuardConfirmationDialogData;
    const dialogRef = dialog.open(ConfirmationDialogComponent, dialogData);
    if (!refresh) {
      return dialogRef.afterClosed();
    }
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.reload();
      }
    });
  }

  ngOnInit(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = "ignore";

    this.route.params.subscribe((params) => {
      const code = params.id;
      this.productCode = code?.toString();
      this.creation = false;
      this.duplication = false;
      const duplicateCode = localStorage.getItem("duplicate");

      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      if (code && code.length) {
        this.initialiseState(code, false);
      } else if (duplicateCode !== null) {
        this.duplication = true;
        localStorage.removeItem("duplicate");
        this.initialiseState(duplicateCode, true);
      } else {
        this.creation = true;
        this.initialiseState("", false);
      }
    });

    this.loadTenantData();
    this.loadTimezoneChanges();

    //Initialize FormGroup
    this.createProductForm();
    this.loadProductInfo();
    this.loadLangChanges();
    this.resetCreation();

    //Search subscriptions
    this.setProductGroupSearchSubscription();

    this.loadLocales();
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  getToolTipUnitPrice(): string {
    if(!this.currentProduct.unitPriceNet){
      return ''
    }

    const unitTax = this.currentTax?.rateType?.code === 'PERCENTAGE' ? ' %' : this.coinSymbol;
    const labels = [
      'Products.value',
      'Tax.tax',
      'Tax.taxRegion'
    ];

    return this.regionMatchedLedSite?.description
    ? `${this.translate.instant(labels[0])+': '}${this.currentProduct?.unitPriceNet} ${this.coinSymbol}\n${this.translate.instant(labels[1])+': '+this.currentTax?.rate + unitTax}\n${this.translate.instant(labels[2])+': '+ this.regionMatchedLedSite?.description}`
    : this.currentTax?.description
    ? `${this.translate.instant(labels[0])+': '+this.currentProduct?.unitPriceNet} ${this.coinSymbol}\n${this.translate.instant(labels[1])+': '+this.currentTax.rate + unitTax}`
    : `${this.translate.instant(labels[0])+': '+this.currentProduct?.unitPriceNet} ${this.coinSymbol}`;
  }

  getTaxRegionLedSite(taxToken: string){
    this.taxSub = this.taxService.getTax(taxToken).pipe(
      switchMap((currentTax) =>
        this.sitesService.getEnabledSites(undefined, undefined, undefined, undefined).pipe(
          map((response) => response.result.items.find(i => i.ledSite === true)),
          filter((ledSite): ledSite is SiteDTO => ledSite !== undefined),
          map((ledSite) => ({ currentTax, ledSite }))
        )
      ),
      map(({currentTax, ledSite}) => {
        const matchedTaxRegion = currentTax.taxRegions?.find(
          (taxRegion) => taxRegion?.region?.code === ledSite?.region?.code
        );
        return {currentTax, ledSite, matchedRegion: matchedTaxRegion?.region};
      })
    ).subscribe(({ currentTax, ledSite, matchedRegion }) => {
      this.currentTax = currentTax;
      this.regionMatchedLedSite = matchedRegion;
    });
  }

  loadTenantData(): void {
    this.tenantDataSub = this.tenantData$.subscribe((data: any) => {
      if (data) {
        this.forecourtUnitPriceDecimalPlaces =
          data.forecourtUnitPriceDecimalPlaces;
        this.unitPriceDecimalPlaces = data.unitPriceDecimalPlaces;
        this.dateTimeFormat = data.datetimeFormat;
        this.coinSymbol = data.currency.symbol;
        this.uomDecimalPlaces = data.uomDecimalPlaces;
        this.forecourtUnitPriceDecimalPlaces =data.forecourtUnitPriceDecimalPlaces;
      }
    });
  }

  loadTimezoneChanges() {
    this.timezoneSubscription = this.timezone$.subscribe((timezone) => {
      this.timezone = timezone;
      if (!this.productDataForm) return;
      this.reload();
    });
  }
  
  loadLocales() {
    this.localesListSub = this.localesList$.subscribe((locales) => {
      if (locales) {
        this.localeDesc = locales.find(({ code }) => code === this.locale).description;
        buildDetailedDescription(
          locales,
          this.fb,
          this.productDataForm,
          FORM_PARAMS.detailedDescription,
        );
        buildDetailedDescription(
          locales,
          this.fb,
          this.productDataForm,
          FORM_PARAMS.detailedShortDescription,
        );
        this.checkPermissions();
      }
    });
  }

  resetCreation() {
    this.createdSub = this.created$.pipe(skip(1)).subscribe((created) => {
      if (created) {
        this.creation = false;
        this.duplication = false;
      }
    });
  }

  createProductForm() {
    this.productDataForm = this.fb.group({
      [FORM_PARAMS.code]: [
        null,
        [
          Validators.required,
          Validators.pattern(/^[A-Za-z0-9]+$/),
          Validators.maxLength(20),
        ],
      ],
      [FORM_PARAMS.description]: [
        null,
        [
          Validators.required,
          FormUtils.noWhitespaceValidator,
          Validators.maxLength(60),
        ],
      ],
      [FORM_PARAMS.detailedDescription]: this.fb.array([]),
      [FORM_PARAMS.enabled]: [true],
      [FORM_PARAMS.isFuel]: [null],
      // [FORM_PARAMS.promptQuantity]: [null],
      // [FORM_PARAMS.promptPrice]: [null],
      // [FORM_PARAMS.priceByWeight]: [null],
      // [FORM_PARAMS.fiscalInfoRequired]: [null],
      // [FORM_PARAMS.fiscalInfoRequired]: [null],
      [FORM_PARAMS.refundable]: [null],
      // [FORM_PARAMS.canSellBelowBuyPrice]: [null],
      [FORM_PARAMS.productFamily]: [
        null,
        [FormUtils.noWhitespaceValidator, FormUtils.isObjectValidator],
      ],
      [FORM_PARAMS.productGroup]: [
        null,
        [FormUtils.noWhitespaceValidator, FormUtils.isObjectValidator],
      ],
      [FORM_PARAMS.tax]: [
        null,
        [
          Validators.required,
          FormUtils.noWhitespaceValidator,
          FormUtils.isObjectValidator,
        ],
      ],
      [FORM_PARAMS.productUnitCode]: [null, Validators.required],
      [FORM_PARAMS.productTypeCode]: [null, Validators.required],
      [FORM_PARAMS.defaultQuantity]: [null, [
        Validators.required,
        Validators.min(0),
        Validators.max(999999.999),
      ]
        
      ],
      [FORM_PARAMS.refundMaxPeriod]: [null, Validators.min(0)],
      [FORM_PARAMS.unitPriceNet]: [
        { value: null, disabled: true },
        [
          Validators.required,
          FormUtils.noWhitespaceValidator,
          Validators.min(0),
        ],
      ],
      [FORM_PARAMS.unitPriceGross]: [
        null,
        [
          Validators.required,
          FormUtils.noWhitespaceValidator,
          Validators.min(0),
        ],
      ],
      [FORM_PARAMS.productColor]: [null],
      [FORM_PARAMS.imageUrl]: [null, Validators.maxLength(300)],
      [FORM_PARAMS.shortDescription]: [
        null,
        [
          Validators.required,
          FormUtils.noWhitespaceValidator,
          Validators.maxLength(20),
        ],
      ],
      [FORM_PARAMS.detailedShortDescription]: this.fb.array([]),
      [FORM_PARAMS.lastSaleDate]: [{ value: null, disabled: true }],
      [FORM_PARAMS.lastBuyDate]: [{ value: null, disabled: true }],
      [FORM_PARAMS.lastSalePrice]: [{ value: null, disabled: true }],
      [FORM_PARAMS.lastBuyPrice]: [null],
      [FORM_PARAMS.maxSellDiscount]: [
        null,
        [Validators.min(0), Validators.max(999999.999)],
      ],
      [FORM_PARAMS.profitMargin]: [{value: null, disabled: true}],
      [FORM_PARAMS.categories]: this.fb.array([]),
      [FORM_PARAMS.properties]: this.fb.array([]),
      [FORM_PARAMS.barcodes]: this.fb.array([]),
      [FORM_PARAMS.productComposite]: this.fb.array([]),
    });
    this.onIsFuelChanges(this.productDataForm);
    this.onUnitChange(this.productDataForm);
  }

  onUnitChange(productForm: FormGroup) {
    productForm
      .get(FORM_PARAMS.productUnitCode)
      .valueChanges.subscribe((productUnitCode) => {
        if (productUnitCode) {
          if (
            this.productUnits[
              this.productUnits.findIndex((el) => el.code === productUnitCode)
            ].fractional
          ) {
            this.relevantUomDecimalPlaces = productForm.get(FORM_PARAMS.isFuel).value ? this.forecourtUomDecimalPlaces : this.uomDecimalPlaces;
          } else {
            this.relevantUomDecimalPlaces = 0;
          }
        }
        if (productForm.get(FORM_PARAMS.defaultQuantity).value) {
          productForm.get(FORM_PARAMS.defaultQuantity)
          .setValue(
            Number(productForm.get(FORM_PARAMS.defaultQuantity).value).toFixed(
              this.relevantUomDecimalPlaces
            )
          );
          productForm.get(FORM_PARAMS.defaultQuantity).markAsTouched();
        }
        setTimeout(() => {
          productForm
            .get(FORM_PARAMS.defaultQuantity)
            .updateValueAndValidity();
        });
      });
  }

  onIsFuelChanges(productForm: FormGroup) {
    productForm.get(FORM_PARAMS.isFuel).valueChanges.subscribe((isFuel) => {
      if (isFuel) {
        this.priceDecimalPlaces = this.forecourtUnitPriceDecimalPlaces;
        this.relevantUomDecimalPlaces = this.productUnits[
          this.productUnits.findIndex(
            (el) =>
              el.code === productForm.get(FORM_PARAMS.productUnitCode).value,
          )
        ].fractional
          ? this.forecourtUomDecimalPlaces
          : 0;

        if (this.productDataForm.controls.unitPriceNet.value) {
          productForm
            .get(FORM_PARAMS.unitPriceNet)
            .setValue(
              Number(this.productDataForm.controls.unitPriceNet.value).toFixed(
                this.forecourtUnitPriceDecimalPlaces,
              ),
            );
        }
        if (this.productDataForm.controls.unitPriceGross.value) {
          productForm
            .get(FORM_PARAMS.unitPriceGross)
            .setValue(
              Number(
                this.productDataForm.controls.unitPriceGross.value,
              ).toFixed(this.forecourtUnitPriceDecimalPlaces),
            );
        }
        if (this.productDataForm.controls.lastBuyPrice.value) {
          productForm
            .get(FORM_PARAMS.lastBuyPrice)
            .setValue(
              Number(
                this.productDataForm.controls.lastBuyPrice.value,
              ).toFixed(this.forecourtUnitPriceDecimalPlaces),
            );
        }
      } else {
        this.priceDecimalPlaces = this.unitPriceDecimalPlaces;
        this.relevantUomDecimalPlaces = this.productUnits.find(el => 
          el.code === productForm.get(FORM_PARAMS.productUnitCode).value)?.fractional
            ? this.uomDecimalPlaces
            : 0;
        
        if (this.productDataForm.controls.unitPriceNet.value) {
          productForm
            .get(FORM_PARAMS.unitPriceNet)
            .setValue(
              Number(this.productDataForm.controls.unitPriceNet.value).toFixed(
                this.unitPriceDecimalPlaces,
              ),
            );
        }
        if (this.productDataForm.controls.unitPriceGross.value) {
          productForm
            .get(FORM_PARAMS.unitPriceGross)
            .setValue(
              Number(
                this.productDataForm.controls.unitPriceGross.value,
              ).toFixed(this.unitPriceDecimalPlaces),
            );
        }
        if (this.productDataForm.controls.lastBuyPrice.value) {
          productForm
            .get(FORM_PARAMS.lastBuyPrice)
            .setValue(
              Number(
                this.productDataForm.controls.lastBuyPrice.value,
              ).toFixed(this.unitPriceDecimalPlaces),
            );
        }
      }
      productForm.get(FORM_PARAMS.unitPriceNet).updateValueAndValidity();
      productForm.get(FORM_PARAMS.unitPriceGross).updateValueAndValidity();
      productForm.get(FORM_PARAMS.defaultQuantity).updateValueAndValidity();
      productForm.get(FORM_PARAMS.lastBuyPrice).updateValueAndValidity();
    });
  }

  loadLangChanges() {
    this.langSubscription = this.translate.onLangChange.subscribe(() => {
      this.titleService.setTitle(this.translate.instant("Products.Details"));
    });
  }

  onSelectionChange(event: MatSelectionListChange) {
    const [option] = event.options;
    const {
      value: { description },
    } = option;
    this.productInfoTabs = this.productInfoTabs.reduce((acc, cur) => {
      if (cur.description === description) {
        return [...acc, { ...cur, selected: true }];
      }
      return [...acc, { ...cur, selected: false }];
    }, []);
  }

  setProductGroupSearchSubscription() {
    this.productGroupsSub = this.productGroupsList$
      .pipe(skip(1))
      .subscribe((productGroups) => {
        if (productGroups) {
          this.productGroupsList = productGroups.map((productGroup) => {
            const { token, code, detailedDescription } = productGroup;
            return {
              token,
              code,
              description: detailedDescription[this.locale],
            };
          });
        }
      });
  }

  validateFirstProductFamilySearch() {
    this.searchProductFamilies("");
  }

  validateFirstProductGroupSearch() {
    this.searchProductGroups("");
  }

  validateFirstTaxSearch() {
    this.searchTaxes("");
  }

  searchProductFamilies(event: KeyboardEvent | string, hasTimer = true): void {
    const searchTerm =
      typeof event === "string"
        ? event
        : (event.target as HTMLInputElement).value;

    clearTimeout(this.searchTimer);
    this.searchTimer = window.setTimeout(
      () => {
        this.isLoadingProductFamily$.next(true);
        this.productFamiliesList$ = this.productFamilyService
          .getProductFamiliesList(null, {
            filterConfig: [{ field: "code" }, { field: "description" }],
            searchTerms: [searchTerm],
          })
          .pipe(
            map(({ items }) => {
              return items.map((item) => ({
                token: item.token,
                code: item.code,
                description: item.detailedDescription[this.locale],
              }));
            }),
            catchError((error) => {
              this.snackbarService.show({
                message: this.translate.instant("ProductFamily.loadError"),
                type: SnackbarType.WARNING,
              });
              return EMPTY;
            }),
            finalize(() => this.isLoadingProductFamily$.next(false)),
            shareReplay()
          );
      },
      hasTimer ? 500 : 0
    );
  }

  searchProductGroups(event: KeyboardEvent | string, hasTimer = true): void {
    const searchTerm =
      typeof event === "string"
        ? event
        : (event.target as HTMLInputElement).value;

    clearTimeout(this.searchTimer);
    this.searchTimer = window.setTimeout(
      () => {
        this.store.dispatch(
          getProductGroupList({
            options: {
              filteringArgs: {
                filterConfig: [{ field: "code" }, { field: "description" }],
                searchTerms: [searchTerm],
              },
            },
          })
        );
      },
      hasTimer ? 500 : 0
    );
  }

  searchTaxes(event: KeyboardEvent | string, hasTimer = true): void {
    const searchTerm =
      typeof event === "string"
        ? event
        : (event.target as HTMLInputElement).value;

    clearTimeout(this.searchTimer);
    this.searchTimer = window.setTimeout(
      () => {
        this.isLoadingTax$.next(true);
        this.taxesService
          .getTaxList(undefined, {
            filterConfig: [
              { field: "description" },
              { field: "receiptDescription" },
            ],
            searchTerms: [searchTerm],
          })
          .pipe(
            take(1),
            tap((result) => {
              const { items } = result;
              this.taxesList = items.map((tax: TaxDTO) => {
                const { token, code, description } = tax;
                return {
                  token,
                  code,
                  description,
                };
              });
            }),
            catchError((error) => {
              this.store.dispatch(
                setSnackbar(
                  SnackBarUtils.setSnackBar(
                    this.translate.instant("Tax.taxesLoadError"),
                    SnackbarType.ERROR
                  )
                )
              );
              return EMPTY;
            }),
            finalize(() => this.isLoadingTax$.next(false))
          )
          .subscribe();
      },
      hasTimer ? 500 : 0
    );
  }

  displayAutocompleteOption(option: {
    code: string;
    displayCode: string;
    description: string;
  }): string {
    return option?.description ?? "";
  }

  openProductFamily() {
    const productFamilyToken =
      this.productDataForm.controls[FORM_PARAMS.productFamily]?.value?.token;
    if (productFamilyToken) {
      return ["/families/family", productFamilyToken];
    }
  }

  openProductGroup() {
    const productGroupToken =
      this.productDataForm.controls[FORM_PARAMS.productGroup]?.value?.token;
    if (productGroupToken) {
      return ["/groups/group", productGroupToken];
    }
  }

  openTax() {
    const taxToken =
      this.productDataForm.controls[FORM_PARAMS.tax]?.value?.token;
    if (taxToken) {
      return ["/taxes/tax", taxToken];
    }
  }

  private loadImageFileName(token: string): void {
    this.manageFileService.fileDetails(token).subscribe({
      next: (file) => {
        this.selectedFilesChip = [{ name: file.name, id: file.id }];
      },
      error: () => {
        this.selectedFilesChip = [{ name: token, id: token }];
      },
    });
  }

  private loadThumbnail(fileId: string): void {
    this.getThumbnail(fileId).subscribe((thumb) => this.thumbnail$.next(thumb));
  }

  private getThumbnail(fileId: string): Observable<SafeUrl> {
    if (this.thumbnailCache[fileId]) {
      return of(this.thumbnailCache[fileId]);
    }

    if (!this.fileThumbnails[fileId]) {
      this.fileThumbnails[fileId] = this.manageFileService
        .getFileThumbnail(fileId)
        .pipe(
          map((blob) => {
            const url = URL.createObjectURL(blob);
            const safeUrl = this.sanitizer.bypassSecurityTrustUrl(url);
            this.thumbnailCache[fileId] = safeUrl;
            return safeUrl;
          })
        );
    }

    return this.fileThumbnails[fileId];
  }

  public openManageFilesDialog(): void {
    const currentImageUrl = this.productDataForm.get(
      FORM_PARAMS.imageUrl
    )?.value;

    this.dialog.open(ManageFilesDialogComponent, {
      data: {
        treatedDtoSelection: currentImageUrl ? [currentImageUrl] : [],
        allowMultiple: false,
        fileType: 'image'
      },
      width: '85%',
      maxHeight: '100vh',
      panelClass: 'search-site-dialog',
      autoFocus: false,
    }).afterClosed().subscribe((fileSubmission: { submitted: boolean, selectedFiles: any[] }) => {
      const { submitted, selectedFiles } = fileSubmission;

      if (!submitted) {
        return;
      }

      if (selectedFiles && selectedFiles.length > 0) {
        const selectedFile = selectedFiles[0];

          const imageUrl = selectedFile?.id ?? selectedFile;

          this.productDataForm.get(FORM_PARAMS.imageUrl)?.setValue(imageUrl);
          this.productDataForm.get(FORM_PARAMS.imageUrl)?.markAsDirty();
          this.productDataForm.get(FORM_PARAMS.imageUrl)?.markAsTouched();

        this.selectedFilesChip = [
          typeof selectedFile === 'object'
            ? selectedFile
            : { name: selectedFile, id: selectedFile }
        ];
      } else {
          const imageControl = this.productDataForm.get(FORM_PARAMS.imageUrl);
          imageControl?.setValue(null);
          imageControl?.markAsDirty();
          imageControl?.markAsTouched();

          this.selectedFilesChip = [];
          this.thumbnail$.next(null);
      }
    });
  }

  loadProductInfo() {
    this.multiSubs = zip(
      this.productUnits$.pipe(skip(1)),
      this.productTypes$.pipe(skip(1)),
      this.categoryList$.pipe(skip(1)),
      this.propertyList$.pipe(skip(1))
    ).subscribe(
      ([productUnits, productTypes, categories, properties]) => {
        if (
          productUnits &&
          productUnits !== null &&
          productUnits !== undefined &&
          productUnits?.length > 0
        ) {
          this.productUnits = productUnits;
          if (this.productUnits?.length > 0) {
            this.productUnits = this.productUnits.map((productUnit) => {
              return {
                code: productUnit?.code,
                description: productUnit?.detailedDescription[this.locale],
                fractional: productUnit?.fractional,
              };
            });
          }
        }

        if (productTypes && productTypes.length) {
          this.productTypes = productTypes;
        }

        this.loadedProductSubs = this.loadedProduct$.pipe(skip(1)).subscribe(
          (product: any) => {
            if (product) {
              if (this.currCode !== product.code && !this.duplication) {
                this.router.navigate(["products/product", product.code]);
              }

              this.currentProduct = cloneDeep(product);
              this.getTaxRegionLedSite(this.currentProduct?.tax?.token)

              if (
                (!this.currCode ||
                  (this.currCode && this.currCode?.length === 0)) &&
                !this.duplication
              ) {
                this.currCode = this.currentProduct.code;
              }

              this.creation = false;
              this.card = {
                avatarUrl: "",
                content: "",
                imageUrl: "",
                current: !this.duplication ? product?.code : "",
                title: !this.duplication
                  ? "[" +
                  product?.code +
                  "] - " +
                  (product?.code?.length > 0 ? product?.description : "")
                  : "Products.newProduct",
                subtitle: !this.duplication
                  ? "Products.product"
                  : "Products.duplication",
              };

              this.setProductForm(product);
              this.checkThumbnail();
            }
            if (product || this.duplication) {
              
              if (categories && categories.length) {
                this.categoryList = categories;
              }
              if (properties && properties.length) {
                this.propertyList = properties;
              }
              
            }
          }
        );
        if (this.creation) {
          if (categories && categories.length) {
            this.categoryList = categories;
          }
          if (properties && properties.length) {
            
            this.propertyList = properties;
          }
        }
        if (this.currCode) {
        this.loadProduct(this.currCode);
        this.currCode = this.duplication ? "" : this.currCode;
      }
      }
    );

    this.store.dispatch(getFamilyProductsList(null));
    this.store.dispatch(getGroupProductsList(null));
    this.store.dispatch(getUnitProductsList(null));
    this.store.dispatch(getProductTypesList(null));
    this.store.dispatch(getBarcodeTypes(null));
    this.store.dispatch(
      getCategoriesByUsage({
        pageReq: {
          query: "is_enabled==1",
          limit: undefined,
          offset: 0,
          realSize: true,
        },
        usageCode: USAGE_CODE,
      })
    );
    this.store.dispatch(
      getPropertiesByUsage({
        pageReq: {
          query: "is_enabled==1",
          limit: undefined,
          offset: 0,
          realSize: true,
        },
        usageCode: USAGE_CODE,
      })
    );
    this.store.dispatch(
      getSitesList({
        options: {
          paging: {
            skip: 0,
            top: 9999,
          },
        },
      })
    );
  }

  getProductProfitMargin(product: any): number {
    if (!product.unitPriceGross || !product.lastBuyPrice) {
      return 0;
    }

    return (product.unitPriceGross / product.lastBuyPrice) * 100;
  }

  public getStepValue(maxDecimals): number {
    return 1 / (Math.pow(10, maxDecimals));
  }

  checkThumbnail() {
    const imageId = this.productDataForm.get(FORM_PARAMS.imageUrl)?.value;
    if (imageId) {
      this.loadThumbnail(imageId);
    }
    this.productDataForm.get(FORM_PARAMS.imageUrl)?.valueChanges
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe((imageId: string | null) => {
        if (imageId) {
          this.loadThumbnail(imageId);
        } else {
          this.thumbnail$.next(null)
        }
      });
  }

  setProductForm(product: any) {
    this.productDataForm.controls.enabled.setValue(
      product && product?.enabled ? product?.enabled : false
    );
    this.productDataForm.controls.isFuel.setValue(
      product && product?.isFuel ? product?.isFuel : false
    );
    // this.productDataForm.controls.promptQuantity.setValue(
    //   product && product?.promptQuantity ? product?.promptQuantity : false
    // );
    // this.productDataForm.controls.promptPrice.setValue(
    //   product && product?.promptPrice ? product?.promptPrice : false
    // );
    // this.productDataForm.controls.priceByWeight.setValue(
    //   product && product?.priceByWeight ? product?.priceByWeight : false
    // );
    // this.productDataForm.controls.fiscalInfoRequired.setValue(
    //   product && product?.fiscalInfoRequired
    //     ? product?.fiscalInfoRequired
    //     : false
    // );
    this.productDataForm.controls.refundable.setValue(
      product && product?.refundable ? product?.refundable : false
    );
    // this.productDataForm.controls.canSellBelowBuyPrice.setValue(
    //   product && product?.canSellBelowBuyPrice
    //     ? product?.canSellBelowBuyPrice
    //     : false
    // );
    this.productDataForm.controls.code.setValue(
      product && product?.code && !this.duplication ? product?.code : null
    );
    this.productDataForm.controls.description.setValue(
      product && product?.detailedDescription && !this.duplication
        ? product?.detailedDescription[this.locale]
        : null
    );
    if (!this.duplication) {
      populateDetailedDescription(
        this.productDataForm.get("detailedDescription") as FormArray,
        this.currentProduct.detailedDescription,
      );
    }
    this.productDataForm.controls.shortDescription.setValue(
      product && product?.detailedShortDescription && !this.duplication
        ? product?.detailedShortDescription[this.locale]
        : null
    );
    if (!this.duplication) {
      populateDetailedDescription(
        this.productDataForm.get("detailedShortDescription") as FormArray,
        this.currentProduct.detailedShortDescription,
      );
    }
    this.productDataForm.controls[FORM_PARAMS.unitPriceNet].setValue(
      product && product?.unitPriceNet && !this.duplication
        ? product?.unitPriceNet.toFixed(
            product?.isFuel
              ? this.forecourtUnitPriceDecimalPlaces
              : this.unitPriceDecimalPlaces
          )
        : 0
    );
    this.productDataForm.controls[FORM_PARAMS.unitPriceGross].setValue(
      product && product?.unitPriceGross && !this.duplication
        ? product?.unitPriceGross.toFixed(
            product?.isFuel
              ? this.forecourtUnitPriceDecimalPlaces
              : this.unitPriceDecimalPlaces
          )
        : 0
    );
    this.productDataForm.controls[FORM_PARAMS.defaultQuantity].setValue(
      (product?.defaultQuantity || product?.defaultQuantity === 0) &&
        !this.duplication
        ? product?.defaultQuantity
        : null
    );
    this.productDataForm.controls.maxSellDiscount.setValue(
      (product?.maxSellDiscount || product?.maxSellDiscount === 0) &&
        !this.duplication
        ? product?.maxSellDiscount
        : null
    );
    this.productDataForm.controls[FORM_PARAMS.refundMaxPeriod].setValue(
      (product?.refundMaxPeriod || product?.refundMaxPeriod === 0) &&
        !this.duplication
        ? product?.refundMaxPeriod
        : null
    );
    let color = FormUtils.hexToRgb(product?.color);
    this.productDataForm.controls.productColor.setValue(
      color && product?.color && !this.duplication
        ? new Color(color.r, color.g, color.b)
        : null
    );
    this.productDataForm.controls.imageUrl.setValue(
      product && product?.imageUrl && !this.duplication
        ? product?.imageUrl
        : null
    );
    this.productDataForm.controls[FORM_PARAMS.productGroup].setValue(
      !product.productGroup
        ? null
        : {
            token: product.productGroup.token,
            code: product.productGroup.code,
            description: product.productGroup.detailedDescription[this.locale],
          }
    );
    this.productDataForm.controls[FORM_PARAMS.productFamily].setValue(
      !product.productFamily
        ? null
        : {
            token: product.productFamily.token,
            code: product.productFamily.code,
            description: product.productFamily.detailedDescription[this.locale],
          }
    );
    this.productDataForm.controls[FORM_PARAMS.tax].setValue(
      !product.tax
        ? null
        : {
            token: product.tax.token,
            code: product.tax.code,
            description: product.tax.description,
          }
    );
    this.productDataForm.patchValue(
      {
        productUnitCode: product?.productUnit?.code
          ? product?.productUnit?.code
          : null,
      },
      { emitEvent: true, onlySelf: false }
    );
    this.productDataForm.patchValue(
      {
        productTypeCode: product?.productTypeCode
          ? product?.productTypeCode
          : null,
      },
      { emitEvent: true, onlySelf: false }
    );
    this.setDateField(this.productDataForm, "lastSaleDate");
    this.setDateField(this.productDataForm, "lastBuyDate");
    this.productDataForm.controls[FORM_PARAMS.lastSalePrice].setValue(
      product && product?.lastSalePriceGross && !this.duplication
        ? product?.lastSalePriceGross.toFixed(
            product?.isFuel
              ? this.forecourtUnitPriceDecimalPlaces
              : this.unitPriceDecimalPlaces
          )
        : 0
    );
    this.productDataForm.controls[FORM_PARAMS.lastBuyPrice].setValue(
      product && product?.lastBuyPrice && !this.duplication
        ? product?.lastBuyPrice.toFixed(
            product?.isFuel
              ? this.forecourtUnitPriceDecimalPlaces
              : this.unitPriceDecimalPlaces
          )
        : null
    );
    this.productDataForm.controls[FORM_PARAMS.profitMargin].setValue(
      this.getProductProfitMargin(product)
    )

    if (product.imageUrl) {
      this.loadImageFileName(product.imageUrl);
    }
  }

  checkPermissions(): void {
    // Espera até roles estarem carregados
    this.rolePermissionsService["roles$"]
      .pipe(
        filter((roles) => roles.length > 0),
        take(1),
        switchMap(() =>
          this.rolePermissionsService.hasPermission(
            "PRODUCT_MANAGEMENT",
            "WRITE"
          )
        ),
        takeUntil(this.destroy$)
      )
      .subscribe((canEdit) => {
        this.canWrite = canEdit;
        if (!canEdit) {
          this.disableFormControls(this.productDataForm);
        }
      });

    this.canWrite$ = this.rolePermissionsService.hasPermission(
      "PRODUCT_MANAGEMENT",
      "WRITE"
    );

    this.canReadProductFamilies$ = this.rolePermissionsService.hasPermission(
      "PRODUCT_FAMILY_MANAGEMENT",
      "READ"
    );

    this.canReadProductGroups$ = this.rolePermissionsService.hasPermission(
      "PRODUCT_GROUP_MANAGEMENT",
      "READ"
    );

    this.canReadTaxes$ = this.rolePermissionsService.hasPermission(
      "TAX_MANAGEMENT",
      "READ"
    );
  }

  protected disableFormControls(form: FormGroup): void {
    const fields = [
      FORM_PARAMS.enabled,
      FORM_PARAMS.isFuel,
      // FORM_PARAMS.promptQuantity,
      // FORM_PARAMS.promptPrice,
      // FORM_PARAMS.priceByWeight,
      // FORM_PARAMS.fiscalInfoRequired,
      FORM_PARAMS.refundable,
      // FORM_PARAMS.canSellBelowBuyPrice,
      FORM_PARAMS.code,
      FORM_PARAMS.description,
      FORM_PARAMS.productUnitCode,
      FORM_PARAMS.productTypeCode,
      FORM_PARAMS.productFamily,
      FORM_PARAMS.productGroup,
      FORM_PARAMS.tax,
      FORM_PARAMS.unitPriceNet,
      FORM_PARAMS.unitPriceGross,
      FORM_PARAMS.defaultQuantity,
      FORM_PARAMS.refundMaxPeriod,
      FORM_PARAMS.productColor,
      FORM_PARAMS.imageUrl,
      FORM_PARAMS.shortDescription,
      FORM_PARAMS.lastSaleDate,
      FORM_PARAMS.lastBuyDate,
      FORM_PARAMS.lastSalePrice,
      FORM_PARAMS.lastBuyPrice,
      FORM_PARAMS.maxSellDiscount,
      FORM_PARAMS.categories,
      FORM_PARAMS.properties,
      FORM_PARAMS.barcodes,
      FORM_PARAMS.composite,
      FORM_PARAMS.productComposite,
      FORM_PARAMS.detailedDescription,
      FORM_PARAMS.detailedShortDescription,
      FORM_PARAMS.profitMargin
    ];

    fields.forEach((field) => {
      const control = form.get(field);
      control?.disable();
    });
  }

  setDateField(productForm: FormGroup, fieldParam: string) {
    const value = this.duplication
      ? null
      : this.currentProduct[fieldParam]
        ? (this.timezone === 'UTC'
          ? moment.utc(this.currentProduct[fieldParam]).format(this.dateTimeFormat ?? "DD/MM/YYYY HH:mm:ss")
          : moment(this.currentProduct[fieldParam]).format(this.dateTimeFormat ?? "DD/MM/YYYY HH:mm:ss"))
      : null;

    productForm.controls[FORM_PARAMS[fieldParam]].setValue(value);
  }

  checkHasMoreDecimalPlaces(value: number): boolean {
    if (!value) {
      return false;
    }
    if (this.currentProduct.isFuel) {
      return this.hasMoreDecimalPlacesThanDefault(
        value,
        this.forecourtUnitPriceDecimalPlaces
      );
    }
    return this.hasMoreDecimalPlacesThanDefault(
      value,
      this.unitPriceDecimalPlaces
    );
  }

  public hasMoreDecimalPlacesThanDefault(
    value: number,
    decimalPlaces: number
  ): boolean {
    const decimalString = value.toString().split(".")[1];
    return decimalString ? decimalString.length > decimalPlaces : false;
  }

  initialiseState(code: string, duplicate?: boolean) {
    if (code) {
      this.currCode = code;
    } else {
      this.reset();
      this.currCode = "";
      this.card = {
        avatarUrl: "",
        content: "",
        imageUrl: "",
        current: "",
        title: "Products.newProduct",
        subtitle: this.duplication
          ? "Products.duplication"
          : "Products.creation",
      };
    }
  }

  clearFormControl(form: FormGroup, productControl: string): void {
    form.controls[productControl].setValue(null);
    form.markAsDirty();
    if (productControl === FORM_PARAMS.imageUrl) {
      this.thumbnail$.next(false);
    }
  }


  getColorPickerBgColor(color: Color): string {
    if (color) {
      return getColorByBgColor(color.hex);
    }
  }

  openDescriptionLocaleFormDialog() {
    const detailedDescriptionBackup = [...this.productDataForm.get("detailedDescription").value];
    const dialogData = {
      data: {
        parentForm: this.productDataForm,
        formParam: FORM_PARAMS.detailedDescription,
      },
      width: '400px',
    };
    const dialogRef = this.dialog.open(DescriptionLocaleFormDialogComponent, dialogData);
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        setFormAfterDialogClosed(
          this.locale,
          this.productDataForm,
          FORM_PARAMS.detailedDescription,
          FORM_PARAMS.description
        );
      } else {
        this.productDataForm.get("detailedDescription").setValue(detailedDescriptionBackup);
      }
    });
  }

  openShortDescriptionLocaleFormDialog() {
    const detailedShortDescriptionBackup = [...this.productDataForm.get("detailedShortDescription").value];
    const dialogData = {
      data: {
        parentForm: this.productDataForm,
        formParam: FORM_PARAMS.detailedShortDescription,
      },
      width: '400px',
    };
    const dialogRef = this.dialog.open(DescriptionLocaleFormDialogComponent, dialogData);
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        setFormAfterDialogClosed(
          this.locale,
          this.productDataForm,
          FORM_PARAMS.detailedShortDescription,
          FORM_PARAMS.shortDescription
        );
      } else {
        this.productDataForm.get("detailedShortDescription").setValue(detailedShortDescriptionBackup);
      }
    });
  }

  loadProduct(code: string) {
    if (code && code?.length > 0) {
      this.store.dispatch(getProduct({ code: code }));
    }
  }

  reset() {
    this.store.dispatch(resetProduct());
  }

  back() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.location.back();
  }

  onSubmit() {
    if (!this.productDataForm.valid) {
      this.productDataForm.markAllAsTouched();
      this.snackbarService.show({
        message: this.translate.instant("Products.invalid"),
        type: SnackbarType.ERROR,
      });
      return;
    }

    if (this.productDataForm.pristine && !this.creation && !this.duplication) {
      this.snackbarService.show({
        message: this.translate.instant("Products.NoChanges"),
        type: SnackbarType.WARNING,
      });
      return;
    }

    let product: any = {
      enabled: this.productDataForm.controls.enabled.value
        ? this.productDataForm.controls.enabled.value
        : false,
      isFuel: this.productDataForm.controls.isFuel.value
        ? this.productDataForm.controls.isFuel.value
        : false,
      // promptQuantity: this.productDataForm.controls.promptQuantity.value
      //   ? this.productDataForm.controls.promptQuantity.value
      //   : false,
      // promptPrice: this.productDataForm.controls.promptPrice.value
      //   ? this.productDataForm.controls.promptPrice.value
      //   : false,
      // priceByWeight: this.productDataForm.controls.priceByWeight.value
      //   ? this.productDataForm.controls.priceByWeight.value
      //   : false,
      // fiscalInfoRequired: this.productDataForm.controls.fiscalInfoRequired.value
      //   ? this.productDataForm.controls.fiscalInfoRequired.value
      //   : false,
      refundable: this.productDataForm.controls.refundable.value
        ? this.productDataForm.controls.refundable.value
        : false,
      // canSellBelowBuyPrice: this.productDataForm.controls.canSellBelowBuyPrice
      //   .value
      //   ? this.productDataForm.controls.canSellBelowBuyPrice.value
      //   : false,
      code: this.productDataForm.controls.code.value
        ? this.productDataForm.controls.code.value
        : null,
      description: this.productDataForm.controls.description.value
        ? this.productDataForm.controls.description.value
        : null,
      detailedDescription: setDetailedDescription(
        this.productDataForm,
        FORM_PARAMS.detailedDescription,
        FORM_PARAMS.description, 
        this.locale
      ),
      color: this.productDataForm.controls.productColor.value
        ? this.productDataForm.controls.productColor.value?.hex
        : null,
      imageUrl: this.productDataForm.controls.imageUrl.value
        ? this.productDataForm.controls.imageUrl.value
        : null,
      defaultQuantity:
        this.productDataForm.controls.defaultQuantity.value ||
        this.productDataForm.controls.defaultQuantity.value === 0
          ? this.productDataForm.controls.defaultQuantity.value
          : null,
      maxSellDiscount:
        this.productDataForm.controls.maxSellDiscount.value ||
        this.productDataForm.controls.maxSellDiscount.value === 0
          ? this.productDataForm.controls.maxSellDiscount.value
          : null,
      refundMaxPeriod:
        this.productDataForm.controls.refundMaxPeriod.value ||
        this.productDataForm.controls.refundMaxPeriod.value === 0
          ? this.productDataForm.controls.refundMaxPeriod.value
          : null,
      unitPriceNet: this.productDataForm.controls.unitPriceNet.value
        ? this.productDataForm.controls.unitPriceNet.value
        : 0,
      unitPriceGross: this.productDataForm.controls.unitPriceGross.value
        ? this.productDataForm.controls.unitPriceGross.value
        : 0,
      productUnitCode: this.productDataForm.controls.productUnitCode.value
        ? this.productDataForm.controls.productUnitCode.value
        : null,
      productTypeCode: this.productDataForm.controls.productTypeCode.value
        ? this.productDataForm.controls.productTypeCode.value
        : null,
      productFamilyToken: this.productDataForm.controls.productFamily.value
        ?.token
        ? this.productDataForm.controls.productFamily.value.token
        : null,
      productGroupToken: this.productDataForm.controls.productGroup.value?.token
        ? this.productDataForm.controls.productGroup.value.token
        : null,
      taxToken: this.productDataForm.controls.tax.value.token
        ? this.productDataForm.controls.tax.value.token
        : null,
      shortDescription: this.productDataForm.controls.shortDescription.value
        ? this.productDataForm.controls.shortDescription.value
        : null,
      detailedShortDescription: setDetailedDescription(
        this.productDataForm,
        FORM_PARAMS.detailedShortDescription,
        FORM_PARAMS.shortDescription,
        this.locale
      ),
      categories: CategoriesAndPropsUtils.setFormCategories(
        this.productDataForm.controls.categories.value
      ),
      properties: CategoriesAndPropsUtils.setFormProperties(
        this.productDataForm.controls.properties.value
      ),
      barcodes: this.productDataForm.controls.barcodes.value ?? null,
      productComposite: this.productDataForm.controls.productComposite.value
        ? this.setPackProductCode(
            this.productDataForm.controls.productComposite.value
          )
        : null,
      composite:
        !!this.productDataForm.controls.productComposite.value.length &&
        !this.productDataForm.controls.isFuel.value
          ? true
          : false,
      profitMargin: this.productDataForm.controls.profitMargin.value 
        ?? null,
      lastBuyPrice: this.productDataForm.controls.lastBuyPrice.value
        ?  this.productDataForm.controls.lastBuyPrice.value
        : null
    };

    if (this.currCode.length === 0) {
      this.store.dispatch(createProduct({ product }));
    } else {
      product = { ...product, currCode: this.currCode };
      this.store.dispatch(updateProduct({ product }));
    }

    this.productDataForm.markAsUntouched();
    this.productDataForm.markAsPristine();
  }

  setPackProductCode(packArr: PackExtendedDTO[]): PackDTO[] {
    return packArr.map(({ code, product, quantity }) => ({
      code,
      productCode: product.code,
      quantity,
    }));
  }

  refresh() {
    if (isAuthenticated(this.router.url) && !this.productDataForm.pristine) {
      this.confirmDialog(this.dialog, true);
      return;
    } else {
      this.reload();
    }
  }

  reload() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = "reload";
    this.router.navigate(["products/product", this.currCode]);
  }

  new() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = "reload";
    this.router.navigate(["/products/product"]);
    this.creation = true;
  }

  duplicate() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    localStorage.setItem("duplicate", this.currCode);
    this.router.onSameUrlNavigation = "reload";
    this.router.navigate(["products/product", {}]);
  }

  identify(index, item) {
    return item.code;
  }

  ngOnDestroy(): void {
    if (this.createdSub) {
      this.createdSub.unsubscribe();
    }
    if (this.multiSubs) {
      this.multiSubs.unsubscribe();
    }
    if (this.loadedProductSubs) {
      this.loadedProductSubs.unsubscribe();
    }
    if (this.messageSubs) {
      this.messageSubs.unsubscribe();
    }
    if (this.langSubscription) {
      this.langSubscription.unsubscribe();
    }
    if (this.productFamiliesSub) {
      this.productFamiliesSub.unsubscribe();
    }
    if (this.productGroupsSub) {
      this.productGroupsSub.unsubscribe();
    }
    if (this.timezoneSubscription) {
      this.timezoneSubscription.unsubscribe();
    }
    if (this.langSubscription) {
      this.langSubscription.unsubscribe();
    }
    if (this.tenantDataSub) {
      this.tenantDataSub.unsubscribe();
    }
    if (this.localesListSub) {
      this.localesListSub.unsubscribe();
    }
    if(this.taxSub){
      this.taxSub.unsubscribe();
    }

    this.destroy$.next();
    this.destroy$.complete();
  }

  @HostListener("window:beforeunload")
  canDeactivate(): Observable<boolean> | boolean {
    return this.isNavigationAllowed();
  }

  isNavigationAllowed(): Observable<boolean> | boolean {
    if (!isAuthenticated(this.router.url) || this.productDataForm.pristine) {
      return true;
    } else {
      return false;
    }
  }
}
